<!-- confirm-add-bank-dialog.component.html -->

<h2 mat-dialog-title>Save Bank Account?</h2>

<div mat-dialog-content class="dialog-content">
  <p>{{ data.message }}</p>
</div>

<div mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="onClose(false)">No, thanks</button>
  <button mat-flat-button color="primary" (click)="onClose(true)">Yes, add it</button>
</div>
